<template>
  <CModal
    v-model:visible="showModal"
    centered
  >
    <template #header-wrapper>
      <CCardHeader>
        <h4 class="font-weight-bold text-center mb-0">
          New Firmware
        </h4>
      </CCardHeader>
    </template>
    <CCardBody class="pt-3 pb-0">
      <CInput
        v-model="firmwareName"
        label="Firmware Name"
        placeholder="e.g. Console V2"
        @keyup.enter="save"
      />
      <div class="d-flex mt-4 mb-3 align-items-center justify-content-center">
        <CButton
          color="secondary"
          class="mx-auto text-uppercase"
          @click="showModal = false"
        >
          Cancel
        </CButton>
        <CButton
          color="success"
          class="mx-auto text-uppercase btn_yes"
          :disabled="!firmwareName.trim()"
          @click="save"
        >
          Save
        </CButton>
      </div>
    </CCardBody>
    <template #footer-wrapper>
      <span />
    </template>
  </CModal>
</template>

<script>
export default {
  name: "CreateFirmwareModal",
  data() {
    return {
      showModal: false,
      firmwareName: '',
    }
  },
  methods: {
    open() {
      this.firmwareName = ''; 
      this.showModal = true;
    },
    save() {
      if (this.firmwareName.trim()) {
        this.$emit('saved', this.firmwareName.trim());
        this.showModal = false;
      }
    }
  }
}
</script>
